import React from 'react';
import ABTesting from '../../a-b-testing/ABTesting';
import useCurrentLanguage from '../../../i18n/useCurrentLanguage';
import { isProdBuild } from '../../../i18n/environments';
import HeaderA from './HeaderA';
import HeaderB from './HeaderB';
import HeaderC from './HeaderC';
import HeaderD from './HeaderD';
import HeaderE from './HeaderE';

const ABHeader = (props) => {
  const { isEs } = useCurrentLanguage();

  const testConfig = {
    testId: isProdBuild ? 'a9bc85c9-74b1-47a1-bbcb-a632889efa95' : 'acab14fb-c097-45a9-a44b-75201be27738',
    abPages: [HeaderA, HeaderB, HeaderC, HeaderD, HeaderE],
    defaultVersion: HeaderA,
    startDate: '2024-11-01',
    endDate: '2025-11-01',
    url: 'all',
  };
  return <ABTesting {...testConfig} {...props} language={isEs} />;
};

export default ABHeader;
